import { CustomerInput } from '@/types/customer';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function customer(axios: any) {
  async function getCustomers(filter: any) {
    try {
      const response = await axios.get(`/api/customers?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/customer] getCustomers Error', e);
    }
    return null;
  }

  async function getCustomersStats() {
    try {
      const response = await axios.get('/api/customers?PerPage=1');
      if (response?.status === 200) {
        return response.data.totalRecords;
      }
    } catch (e) {
      console.error('[api/customer] getCustomers Error', e);
    }
    return 0;
  }

  async function getCustomer(id: number) {
    const response = await axios.get(`/api/customers/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/customer] updateCustomer Error', e);
    }
    return null;
  }

  async function createCustomer(payload: CustomerInput) {
    const response = await axios.post('/api/customers', camelObjectToSnakeObject(payload, ['taxId']));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/customer] createCustomer Error', e);
    }
    return null;
  }

  async function updateCustomer(id: number | string, payload: CustomerInput) {
    const response = await axios.put(`/api/customers/${id}`, camelObjectToSnakeObject(payload, ['taxId']));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/customer] updateCustomer Error', e);
    }
    return null;
  }

  async function deleteCustomer(id: number) {
    const response = await axios.delete(`/api/customers/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/customer] deleteCustomer Error', e);
    }
    return null;
  }

  async function checkExistingCustomerCode(code: string) {
    const response = await axios.get(`/api/customers/check/${code}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/customer] checkExistingCustomerCode Error', e);
    }
    return {
      exist: false,
      code: '',
    };
  }

  return {
    getCustomers,
    getCustomer,
    getCustomersStats,
    createCustomer,
    updateCustomer,
    deleteCustomer,
    checkExistingCustomerCode,
  };
}
